import api from "../../utils/api/api.utils";
export var getInvites = function () {
    return api.get("/invites/open-invites");
};
